import { useQuery } from '@tanstack/react-query';
import { Navigate, useLocation } from 'react-router-dom';
import { api, ApiError } from '@/lib/api';
import type { AdminPublic } from '@inafana/shared';

interface MeResponse {
  admin: AdminPublic;
}

export function useCurrentAdmin() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => api<MeResponse>('/auth/me'),
    retry: false,
    staleTime: 60_000,
  });
}

export function RequireAdmin({ children }: { children: React.ReactNode }): React.JSX.Element {
  const { data, isLoading, error } = useCurrentAdmin();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (error instanceof ApiError && error.status === 401) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  if (!data?.admin) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
